export default __webpack_public_path__ + "static/media/Keyboard.4d3484ea.jpg";